import React from "react";
import { Button } from "antd";
import styles from "./footer.module.css";

interface IFooterProps {
    handleAdd: () => void;
    handleCancel: () => void;
    canSave: boolean;
    isSaving: boolean;
}

export const Footer = ({ handleAdd, handleCancel, canSave, isSaving }: IFooterProps) => {
    return (
        <div className={styles.footer}>
            <Button variant="outlined" color="primary" onClick={handleCancel} disabled={isSaving}>
                Cancel
            </Button>
            <Button
                variant="solid"
                color="primary"
                onClick={handleAdd}
                disabled={!canSave}
                loading={isSaving}
            >
                Save
            </Button>
        </div>
    );
};
